<template>
    <div class="search-container">
      <div class="search-wrapper">
        <input
          type="text"
          class="search-input"
          :placeholder="placeholder"
          v-model="searchQuery"
          @input="updateSearch"
          @keyup.enter="triggerSearch"
        />
        <span class="search-icon left">
          <img src="../../../images/header/search_icone.svg" alt="Search" />
        </span>
        <span class="search-icon right">
          <img
            v-if="!loading"
            src="../../../images/dashboard/refresh.png"
            alt="Refresh"
            @click="clearSearch"
          />
          <img v-else class="loading-gif" src="../../../images/dashboard/reloading-gif.svg" alt="Loading" />
        </span>
      </div>
      <!-- Status Dropdown -->
      <div class="status-wrapper">
        <select class="status-dropdown" :class="statusClass" v-model="selectedStatus" @change="updateStatus">
          <option value="" class="text-all">All</option>
          <option value="0" class="text-warning">Processing</option>
          <option value="1" class="text-success">Success</option>
          <option value="2" class="text-danger">Failed</option>
        </select>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions } from "vuex";
  
  export default {
    name: "SearchWs",
    data() {
      return {
        searchQuery: "",
        loading: false,
        placeholder: "Search...",
        selectedStatus: "", // Default: Show all statuses
      };
    },
    computed: {
      statusClass() {
        switch (this.selectedStatus) {
          case "0":
            return "text-warning";
          case "1":
            return "text-success";
          case "2":
            return "text-danger";
          default:
            return "";
        }
      },
    },
    methods: {
      ...mapActions('wckits',["setWSearchString", "setWPaginationPage", "fetchWCkits","setWStatus"]),
  
      updateSearch() {
        this.setWPaginationPage(1);
        this.setWSearchString(this.searchQuery);
      },
  
      async triggerSearch() {
        this.loading = true;
        await this.setWPaginationPage(1);
        await this.fetchWCkits();
        this.loading = false;
      },
      updateStatus() {
        this.setWPaginationPage(1);
        this.setWStatus(this.selectedStatus);
        this.fetchWCkits();
      },
  
      clearSearch() {
        this.searchQuery = "";
        this.setWPaginationPage(1);
        this.setWSearchString("").then(() => {
          this.setWStatus("").then(() => {
            this.fetchWCkits();
          });
        });
      },
    },
  };
  </script>
  
  <style scoped>
  .search-container {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 100%;
  }
  
  .search-wrapper {
    max-width: 412px;
    width: 100%;
    position: absolute;
    background-color: #eee;
    border: 1px solid #eee;
    left: 0;
    top: 0;
    border-radius: 25px;
    transform: translate(0, 0);
  }
  
  .search-input {
    font-size: 14px;
    font-weight: 500;
    font-family: TTNormsMedium, sans-serif;
    width: 100%;
    padding: 10px 50px;
    border: none;
    background-color: #fff;
    outline: none;
    border-radius: 5px;
    transition: all 0.5s linear;
  }
  
  .search-input::placeholder {
    color: #757575;
    font-family: TTNormsLight, sans-serif;
    opacity: 0.8;
  }
  
  .search-input:focus {
    background-color: #e3e3e3;
  }
  
  .search-icon {
    position: absolute;
    width: 20px;
  }
  
  .search-icon.right {
    right: 10px;
    top: 8px;
  }
  
  .search-icon.left {
    left: 30px;
    top: 10px;
  }
  
  .search-icon.left img {
    max-width: 70%;
    height: auto;
  }
  
  .search-icon.right img {
    max-width: 100%;
  }
  
  .loading-gif {
    width: 26px;
    height: 23px;
  }
  .status-wrapper {
    position: absolute;
    margin-left: 20px;
    top: 0;
    right: 0;
  }

  .status-dropdown {
    padding: 8px;
    background-color: #fff;
    border: 1px solid #eee;
    border-radius: 5px;
    font-size: 14px;
    cursor: pointer;
    font-family: TTNormsLight, sans-serif;
  }
    
  .status-dropdown option {
    
    font-family: TTNormsLight, sans-serif;
    opacity: 0.8;
  }
  .text-warning {
    color: orange;
  }

  .text-success {
    color: green;
  }

  .text-danger {
    color: red;
  }
  .text-all{
    color: #757575;
  }
  </style>
  